import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import Software from '../home/component/Software/index'
import './index.scss'

class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|解决方案'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="solution-Content">
          <div className="solution-Content-title">
            <div className="solution-Content-title-h1">解决方案</div>
            <div className="solution-Content-title-text">SOLUTION</div>
          </div>
        </div>
        <div style={{ height: '2.857143rem' }}></div>
        <Software titleIshow={false} />
        <Footer></Footer>
      </div>
    )
  }
}

export default index
